// extracted by mini-css-extract-plugin
export default {"input":"IKKLL","field":"HO3N5"};